module.exports = __webpack_public_path__ + "static/media/mask2.c634e657.JPG";